module.exports = __webpack_public_path__ + "static/media/Headshot_burned.8360024f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Headshot_burned.png
// module id = 92
// module chunks = 0